import {Component, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {DonneesRegleModel} from '../parametre-donnees.types';
import {ParametreDonneesStateService} from '../parametre-donnees-state.service';
import {newRandomId} from '../parametre-donnees-helpers';

@Component({
  selector: 'app-parametre-donnees-regles-tab',
  templateUrl: './parametre-donnees-regles-tab.component.html',
  styleUrls: ['./parametre-donnees-regles-tab.component.scss']
})
export class ParametreDonneesReglesTabComponent implements OnChanges {
  @Input() moduleKey = 'produits';

  @ViewChild('regleModalTpl') regleModalTpl!: TemplateRef<unknown>;

  rows: DonneesRegleModel[] = [];
  champCodes: string[] = [];

  editing: DonneesRegleModel | null = null;
  isNew = false;

  readonly operateurs = ['=', '!=', 'contient', '>', '<', 'vide', 'non vide'];
  readonly actions = [
    'Afficher champ',
    'Masquer champ',
    'Rendre obligatoire',
    'Rendre optionnel',
    'Lecture seule',
    'Valeur par défaut'
  ];

  constructor(
    private readonly modal: NgbModal,
    private readonly toastr: ToastrService,
    private readonly state: ParametreDonneesStateService
  ) {}

  ngOnChanges(ch: SimpleChanges): void {
    if (ch['moduleKey']) {
      this.load();
    }
  }

  load(): void {
    this.rows = this.state.getRegles(this.moduleKey);
    this.champCodes = this.state.getChamps(this.moduleKey).map((c) => c.code);
  }

  openAdd(): void {
    this.isNew = true;
    this.editing = {
      id: newRandomId('regle'),
      champSource: this.champCodes[0] || '',
      operateur: '=',
      valeur: '',
      action: this.actions[0],
      champCible: this.champCodes[0] || '',
      statut: 'active',
      priorite: 10,
      active: true
    };
    this.modal.open(this.regleModalTpl, { size: 'lg', backdrop: 'static' });
  }

  openEdit(r: DonneesRegleModel): void {
    this.isNew = false;
    this.editing = JSON.parse(JSON.stringify(r));
    this.modal.open(this.regleModalTpl, { size: 'lg', backdrop: 'static' });
  }

  delete(r: DonneesRegleModel): void {
    if (!confirm('Supprimer cette règle ?')) {
      return;
    }
    this.state.deleteRegleApi(this.moduleKey, r.id).subscribe({
      next: () => {
        this.load();
        this.toastr.success('Règle supprimée.', 'Succès');
      },
      error: () => {}
    });
  }

  save(modal: { close: () => void }): void {
    if (!this.editing) {
      return;
    }
    const e = this.editing;
    e.statut = e.active ? 'active' : 'inactive';
    this.state.saveRegleApi(this.moduleKey, e, this.isNew).subscribe({
      next: () => {
        this.load();
        modal.close();
        this.toastr.success('Règle enregistrée.', 'Succès');
      },
      error: () => {}
    });
  }


}
